import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { Redirect, useHistory } from "react-router-dom";
import {
  FaCamera,
  FaIdCard,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaSave,
  FaSchool,
  FaUserEdit,
  FaUserFriends,
  FaUserPlus,
} from "react-icons/fa";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import BackButton from "../ChildComponent/BackButton";
import { MOTHER_TONGUE_OPTIONS } from "./MotherTongue";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";
import "../css/Admin_css/UpdateStudentDetails.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

const PAGE_FONT =
  'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

const PLACEHOLDER_IMG =
  "https://clevelandpolicefoundation.org/wp-content/uploads/2012/09/female-placeholder.png";

const RELATION_OPTIONS = [
  "Father",
  "Mother",
  "Uncle",
  "Aunt",
  "Grand Father",
  "Grand Mother",
];

const COMMUNITY_OPTIONS = ["SC", "ST", "OBC", "General", "Others"];
const BLOOD_GROUPS = [
  "A+",
  "A-",
  "B+",
  "B-",
  "AB+",
  "AB-",
  "O+",
  "O-",
  "Unknown",
];
const YES_NO = ["Yes", "No"];
const RELIGIONS = [
  "Hindu",
  "Muslim",
  "Christian",
  "Sikh",
  "Buddhist",
  "Jain",
  "Other",
];

function admissionLabel(id) {
  const s = id == null ? "" : String(id).trim();
  if (s === "ADMTYPE01") return "Re-admission";
  if (s === "ADMTYPE02") return "New admission";
  return s || "—";
}

function fmt(v) {
  if (v == null || String(v).trim() === "") return "—";
  return String(v);
}

function normalizeCommunity(raw) {
  const v = String(raw ?? "").trim();
  if (!v) return "";
  const match = COMMUNITY_OPTIONS.find(
    (opt) => opt.toLowerCase() === v.toLowerCase()
  );
  return match || v;
}

//Created By Cursor
function Field({ label, htmlFor, children, required, optional, className = "" }) {
  return (
    <div className={`sr-field${className ? ` ${className}` : ""}`}>
      <label className="sr-field__label" htmlFor={htmlFor}>
        {label}
        {required ? <span className="sr-field__req">*</span> : null}
        {optional ? <span className="sr-field__opt">Optional</span> : null}
      </label>
      {children}
    </div>
  );
}

//Created By Cursor
function SectionCard({ icon: Icon, title, subtitle, step, children, extra }) {
  return (
    <section className="sr-section stur-section stur-section--compact">
      <div className="sr-section__head stur-section__head">
        <span className="stur-section__step" aria-hidden>
          {step || (Icon ? <Icon /> : null)}
        </span>
        <div className="min-w-0">
          <h2 className="sr-section__title">{title}</h2>
          {subtitle ? <p className="sr-section__sub">{subtitle}</p> : null}
        </div>
        {extra ? <div className="sr-section__extra">{extra}</div> : null}
      </div>
      <div className="sr-section__body">{children}</div>
    </section>
  );
}

const UpdateStudentDetails = () => {
  const history = useHistory();
  const photoInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [state, setState] = useState({
    loggedIn: !!localStorage.getItem("token"),
    student_name: "",
    dob: "",
    gender: "",
    community: "",
    RELIGION: "",
    AdharNo: "",
    nationality: "Indian",
    village_town: "",
    post_locality: "",
    police_station: "",
    current_address: "",
    permanent_address: "",
    FatherName: "",
    fatherOccupation: "Farmer",
    father_qualification: "",
    father_aadhar: "",
    motherName: "",
    motherOccupation: "House Wife",
    mother_qualification: "",
    mother_aadhar: "",
    contact1: "",
    contactName_1: "",
    relation_1: "Father",
    contact2: "",
    contactName_2: "",
    relation_2: "Mother",
    email: "",
    mSTUDetails: [],
    StateSpecificIdName: "",
    StateSpecificIdValue: "",
    PreviousSchoolDetails: "",
    admission_date: "",
    caste: "",
    bloodgroup: "",
    mother_tongue: "",
    height: "",
    weight: "",
    birth_place: "",
    student_pen: "",
    student_apaar: "",
    bpl_beneficiary: "No",
    physical_disability: "No",
    student_img_path: PLACEHOLDER_IMG,
    guardians: [],
  });

  useEffect(() => {
    const mSTDetails = JSON.parse(localStorage.getItem("STDetails")) || [];
    if (mSTDetails.length > 0) {
      const details = mSTDetails[0];
      const classDetails = details.class?.[0] || {};
      const contactDetails = details.contact_details || [];
      const family = details.family_details?.[0] || details;

      setState((prev) => ({
        ...prev,
        student_name: details.stu_name || "",
        student_img_path: details.student_img_path || PLACEHOLDER_IMG,
        StateSpecificIdName: details.state_specific_id_name || "",
        StateSpecificIdValue: details.state_specific_id_value || "",
        PreviousSchoolDetails:
          details.previous_school_name || details.PreviousSchoolDetails || "",
        nationality: details.nationality || "Indian",
        AdharNo: details.adharcard_no || "",
        RELIGION: details.religion || "",
        dob: details.birthday || "",
        gender: details.gender || "",
        community: normalizeCommunity(details.community),
        caste: details.caste || "",
        bloodgroup: details.bloodgroup || "",
        mother_tongue: details.mother_tongue || "",
        height: details.height || "",
        weight: details.weight || "",
        birth_place: details.birth_place || "",
        student_pen: details.student_pen || "",
        student_apaar: details.student_apaar || "",
        bpl_beneficiary: details.bpl_beneficiary || "No",
        physical_disability: details.physical_disability || "No",
        admission_date:
          classDetails.registration_date || details.admission_date || "",
        current_address: details.current_address || "",
        permanent_address: details.permanent_address || "",
        village_town: details.village_town || "",
        post_locality: details.post_locality || "",
        police_station: details.police_station || "",
        FatherName: family.father_name || details.father_name || "",
        fatherOccupation:
          family.father_occupation || details.father_occupation || "Farmer",
        father_qualification:
          family.father_qualification || details.father_qualification || "",
        father_aadhar: family.father_aadhar || details.father_aadhar || "",
        motherName: family.mother_name || details.mother_name || "",
        motherOccupation:
          family.mother_occupation || details.mother_occupation || "House Wife",
        mother_qualification:
          family.mother_qualification || details.mother_qualification || "",
        mother_aadhar: family.mother_aadhar || details.mother_aadhar || "",
        email: details.email_id || "",
        mSTUDetails: mSTDetails,
        guardians: details.gaurdian_details || [],
        contact1: contactDetails[0]?.contact_number || "",
        contactName_1: contactDetails[0]?.contact_person_name || "",
        relation_1: contactDetails[0]?.contact_person_relation || "Father",
        contact2: contactDetails[1]?.contact_number || "",
        contactName_2: contactDetails[1]?.contact_person_name || "",
        relation_2: contactDetails[1]?.contact_person_relation || "Mother",
      }));
    }
  }, []);

  const studentMeta = useMemo(() => {
    const details = state.mSTUDetails[0];
    if (!details) {
      return { enroll: "", classLabel: "", session: "", cls: {}, srn: "" };
    }
    const cls = details.class?.[0] || {};
    const parts = [cls.class_name, cls.section_name].filter(Boolean);
    return {
      enroll: details.student_enrollment_no || "",
      classLabel: parts.join(" · ") || "",
      session: cls.session_name || cls.session_id || "",
      cls,
      srn: details.sr_admission_no || "",
    };
  }, [state.mSTUDetails]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prev) => ({ ...prev, [id]: value }));
  };

  const handleGenderChange = (e) => {
    const value = e?.target?.value ?? "";
    setState((prev) => ({ ...prev, gender: value }));
  };

  const handleCommunityChange = (e) => {
    const value = e?.target?.value ?? "";
    setState((prev) => ({
      ...prev,
      community: normalizeCommunity(value),
    }));
  };

  const handleCopyAddress = (e) => {
    const checked = Boolean(e?.target?.checked);
    if (checked) {
      setState((prev) => ({
        ...prev,
        permanent_address: prev.current_address,
      }));
    }
  };

  const goToDetails = () => {
    const details = state.mSTUDetails[0];
    if (!details) {
      history.goBack();
      return;
    }
    const classDetails = details.class?.[0] || {};
    const student_id = details.student_enrollment_no;
    const session_id = classDetails.session_id;
    if (student_id && session_id) {
      history.push(`/AdminMain/StudentDetails/${student_id}/${session_id}`);
    } else {
      history.goBack();
    }
  };

  const validateForm = () => {
    if (!state.student_name.trim()) {
      myToast.notify_warning("Student name is required");
      return false;
    }
    if (!state.dob) {
      myToast.notify_warning("Date of birth is required");
      return false;
    }
    if (!state.gender) {
      myToast.notify_warning("Gender is required");
      return false;
    }
    if (!state.community) {
      myToast.notify_warning("Community is required");
      return false;
    }
    if (state.AdharNo && !/^\d{12}$/.test(state.AdharNo)) {
      myToast.notify_warning("Aadhaar number must be exactly 12 digits");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const staffData = SessionManager.getStaffDetails();
      const staff_id = staffData.staff_id;
      const enrollNo = state.mSTUDetails[0]?.student_enrollment_no;

      const params = {
        enrollment_no: enrollNo,
        student_name: state.student_name,
        dob: state.dob,
        gender: state.gender,
        community: state.community,
        religion: state.RELIGION,
        aadhar_no: state.AdharNo,
        nationality: state.nationality,
        caste: state.caste,
        village_town: state.village_town,
        post_locality: state.post_locality,
        police_station: state.police_station,
        curAddress: state.current_address,
        perAddress: state.permanent_address,
        father_name: state.FatherName,
        father_occupation: state.fatherOccupation,
        father_qualification: state.father_qualification,
        father_aadhar: state.father_aadhar,
        mother_name: state.motherName,
        mother_occupation: state.motherOccupation,
        mother_qualification: state.mother_qualification,
        mother_aadhar: state.mother_aadhar,
        contact1: state.contact1,
        contact2: state.contact2,
        contact_person_name1: state.contactName_1,
        contact_person_name2: state.contactName_2,
        contact_person_relation1: state.relation_1,
        contact_person_relation2: state.relation_2,
        email: state.email,
        bloodgroup: state.bloodgroup,
        mother_tongue: state.mother_tongue,
        height: state.height || "0",
        weight: state.weight || "0",
        student_pen: state.student_pen,
        student_apaar: state.student_apaar,
        bpl_beneficiary: state.bpl_beneficiary || "No",
        physical_disability: state.physical_disability || "No",
        state_specific_id_name: state.StateSpecificIdName,
        state_specific_id_value: state.StateSpecificIdValue,
        previous_school_name: state.PreviousSchoolDetails,
        birth_place: state.birth_place,
        staff_id: staff_id,
        school_code: SCHOOL_CODE,
      };

      const response = await axios.get(
        `${API_BASE()}updateStudentPersonalDetails.php`,
        { params }
      );

      if (response.data.api_status === "OK") {
        myToast.notify_success("Student details updated successfully");
        goToDetails();
      } else {
        throw new Error(response.data.message || "Update failed");
      }
    } catch (error) {
      myToast.notify_warning(error.message || "Update failed");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      myToast.notify_warning("Please select a file.");
      return;
    }
    if (!file.type.startsWith("image/")) {
      myToast.notify_warning("Please select a valid image file.");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedFile(file);
      setPreviewURL(reader.result);
    };
    reader.onerror = () => myToast.notify_warning("Failed to read file.");
    reader.readAsDataURL(file);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      myToast.notify_warning("Please select an image first.");
      return;
    }
    const staffData = SessionManager.getStaffDetails();
    const staff_id = staffData?.staff_id;
    const student_id = state.mSTUDetails[0]?.student_enrollment_no;
    if (!staff_id || !student_id) {
      myToast.notify_warning("Missing staff or student ID");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("image", selectedFile);
    formData.append("enrollment_no", student_id);
    formData.append("staff_id", staff_id);

    try {
      const response = await axios.post(
        `${API_BASE()}uploadStudentPic.php`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.api_status === "OK") {
        myToast.notify_success(
          response.data.api_remark || "Image uploaded successfully!"
        );
        goToDetails();
      } else {
        myToast.notify_warning(response.data.api_remark || "Upload failed");
      }
    } catch (error) {
      console.error("Upload error:", error);
      myToast.notify_warning("Image upload failed.");
    } finally {
      setUploading(false);
    }
  };

  const busy = loading || uploading;
  const photoSrc =
    previewURL ||
    (state.student_img_path
      ? `${state.student_img_path}${
          state.student_img_path.includes("?") ? "&" : "?"
        }v=1`
      : PLACEHOLDER_IMG);

  if (!state.loggedIn) {
    return <Redirect to="/" />;
  }

  return (
    <div
      className="content payroll-page sm-page sr-page stur-page usd-page"
      style={{ background: COLORS.white, fontFamily: PAGE_FONT }}
    >
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <span style={{ color: COLORS.white }}>
                {" "}
                Update Students Details
              </span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell">
        <header className="sm-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon" aria-hidden>
              <FaUserEdit />
            </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Update Students Details</h1>
              <p className="sm-hero__sub">
                {state.student_name
                  ? [
                      state.student_name,
                      studentMeta.classLabel,
                      studentMeta.session,
                    ]
                      .filter(Boolean)
                      .join(" · ")
                  : "Edit personal, family and contact details"}
              </p>
            </div>
          </div>
          <div className="sm-hero__tools">
            <button
              type="submit"
              form="usd-form"
              className="sr-btn sr-btn--primary usd-save-btn"
              disabled={busy}
            >
              <FaSave aria-hidden />
              {loading ? "Saving…" : "Save"}
            </button>
          </div>
        </header>

        <div className="sr-body stur-body">
          {busy && !state.mSTUDetails.length ? (
            <div className="usd-loading">
              <MyLoader />
            </div>
          ) : null}

          <form id="usd-form" onSubmit={handleSubmit} className="usd-form">
            <section className="usd-profile stur-profile">
              <div className="stur-photo-wrap usd-photo-wrap">
                <button
                  type="button"
                  className={`stur-photo${
                    photoSrc && photoSrc !== PLACEHOLDER_IMG
                      ? " stur-photo--has"
                      : ""
                  }`}
                  onClick={() => photoInputRef.current?.click()}
                  aria-label="Choose student photo"
                  disabled={busy}
                >
                  {photoSrc ? (
                    <img className="stur-photo__img" src={photoSrc} alt="" />
                  ) : (
                    <span className="stur-photo__empty">
                      <FaCamera className="stur-photo__icon" aria-hidden />
                      <span className="stur-photo__title">Student photo</span>
                      <span className="stur-photo__hint">Click to choose</span>
                    </span>
                  )}
                </button>
                <input
                  ref={photoInputRef}
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleFileChange}
                  disabled={busy}
                />
              </div>

              <div className="usd-profile__main">
                <div className="stur-badge-row">
                  <span className="stur-badge">
                    ID: {studentMeta.enroll || "—"}
                  </span>
                  {studentMeta.srn ? (
                    <span className="stur-badge stur-badge--soft">
                      SRN: {studentMeta.srn}
                    </span>
                  ) : null}
                  {studentMeta.classLabel ? (
                    <span className="stur-badge stur-badge--soft">
                      {studentMeta.classLabel}
                    </span>
                  ) : null}
                  {state.gender ? (
                    <span className="stur-badge stur-badge--soft">
                      {state.gender}
                    </span>
                  ) : null}
                </div>
                <div className="stur-photo__actions usd-profile__actions">
                  <button
                    type="button"
                    className="stur-photo__btn"
                    onClick={() => photoInputRef.current?.click()}
                    disabled={busy}
                  >
                    Change
                  </button>
                  <button
                    type="button"
                    className="stur-photo__btn"
                    onClick={handleUpload}
                    disabled={!selectedFile || busy}
                  >
                    {uploading ? "Uploading…" : "Upload"}
                  </button>
                </div>
              </div>
            </section>

            <SectionCard
              icon={FaSchool}
              step="01"
              title="Academic"
              subtitle="Class and session (view only)"
            >
              <div className="stur-basic">
                <div className="stur-basic__group stur-basic__group--class">
                  <div className="stur-basic__grid stur-basic__grid--3">
                    <Field label="Class">
                      <span className="sr-input usd-ro">
                        {fmt(studentMeta.cls?.class_name)}
                      </span>
                    </Field>
                    <Field label="Section">
                      <span className="sr-input usd-ro">
                        {fmt(studentMeta.cls?.section_name)}
                      </span>
                    </Field>
                    <Field label="Roll no.">
                      <span className="sr-input usd-ro">
                        {fmt(studentMeta.cls?.student_roll_no)}
                      </span>
                    </Field>
                    <Field label="Session">
                      <span className="sr-input usd-ro">
                        {fmt(studentMeta.session)}
                      </span>
                    </Field>
                    <Field label="Board">
                      <span className="sr-input usd-ro">
                        {fmt(studentMeta.cls?.board_name)}
                      </span>
                    </Field>
                    <Field label="Medium">
                      <span className="sr-input usd-ro">
                        {fmt(studentMeta.cls?.medium_name)}
                      </span>
                    </Field>
                    <Field label="Admission type">
                      <span className="sr-input usd-ro">
                        {admissionLabel(studentMeta.cls?.admission_type_id)}
                      </span>
                    </Field>
                    <Field label="Registration date">
                      <span className="sr-input usd-ro">
                        {fmt(state.admission_date)}
                      </span>
                    </Field>
                    <Field label="Class status">
                      <span className="sr-input usd-ro">
                        {fmt(studentMeta.cls?.status)}
                      </span>
                    </Field>
                  </div>
                </div>
              </div>
            </SectionCard>

            <SectionCard
              icon={FaIdCard}
              step="02"
              title="Admission IDs"
              subtitle="Enrollment, PEN, APAAR and previous school"
            >
              <div className="stur-basic">
                <div className="stur-basic__group stur-basic__group--adm-ids">
                  <div className="stur-basic__group-head">
                    <span className="stur-basic__group-title">IDs</span>
                    <span className="stur-basic__group-line" aria-hidden />
                  </div>
                  <div className="stur-basic__grid stur-basic__grid--4">
                    <Field label="Enrollment No" htmlFor="enrollment_display">
                      <input
                        type="text"
                        className="sr-input"
                        id="enrollment_display"
                        value={studentMeta.enroll}
                        disabled
                      />
                    </Field>
                    <Field label="SRN" htmlFor="srn_display">
                      <input
                        type="text"
                        className="sr-input"
                        id="srn_display"
                        value={studentMeta.srn}
                        disabled
                      />
                    </Field>
                    <Field label="PEN" htmlFor="student_pen" optional>
                      <input
                        type="text"
                        className="sr-input"
                        id="student_pen"
                        value={state.student_pen}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field label="APAAR" htmlFor="student_apaar" optional>
                      <input
                        type="text"
                        className="sr-input"
                        id="student_apaar"
                        value={state.student_apaar}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field
                      label="State Specific Id Name"
                      htmlFor="StateSpecificIdName"
                      optional
                    >
                      <input
                        type="text"
                        className="sr-input"
                        id="StateSpecificIdName"
                        value={state.StateSpecificIdName}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field
                      label="State Specific Id Number"
                      htmlFor="StateSpecificIdValue"
                      optional
                    >
                      <input
                        type="text"
                        className="sr-input"
                        id="StateSpecificIdValue"
                        value={state.StateSpecificIdValue}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                  </div>
                </div>
                <div className="stur-basic__group stur-basic__group--adm-prev">
                  <div className="stur-basic__group-head">
                    <span className="stur-basic__group-title">
                      Previous school
                    </span>
                    <span className="stur-basic__group-line" aria-hidden />
                  </div>
                  <div className="stur-basic__grid stur-basic__grid--1">
                    <Field
                      label="Previous School Details"
                      htmlFor="PreviousSchoolDetails"
                      optional
                      className="usd-field--wide"
                    >
                      <input
                        type="text"
                        className="sr-input"
                        id="PreviousSchoolDetails"
                        value={state.PreviousSchoolDetails}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                  </div>
                </div>
              </div>
            </SectionCard>

            <SectionCard
              icon={FaIdCard}
              step="03"
              title="Basic Information"
              subtitle="Identity, demographics and physical"
            >
              <div className="stur-basic">
                <div className="stur-basic__group stur-basic__group--identity">
                  <div className="stur-basic__group-head">
                    <span className="stur-basic__group-title">Identity</span>
                    <span className="stur-basic__group-line" aria-hidden />
                  </div>
                  <div className="stur-basic__grid stur-basic__grid--4">
                    <Field
                      label="Student Name"
                      htmlFor="student_name"
                      required
                    >
                      <input
                        type="text"
                        className="sr-input"
                        id="student_name"
                        value={state.student_name}
                        onChange={handleChange}
                        required
                        disabled={busy}
                      />
                    </Field>
                    <Field label="Date of Birth" htmlFor="dob" required>
                      <input
                        type="date"
                        className="sr-input"
                        id="dob"
                        value={state.dob}
                        onChange={handleChange}
                        required
                        disabled={busy}
                      />
                    </Field>
                    <Field label="Aadhaar Number" htmlFor="AdharNo" optional>
                      <input
                        type="text"
                        className="sr-input"
                        id="AdharNo"
                        value={state.AdharNo}
                        onChange={handleChange}
                        maxLength={12}
                        inputMode="numeric"
                        disabled={busy}
                      />
                    </Field>
                    <Field label="Gender" htmlFor="gender_male" required>
                      <div
                        className="sr-chip-row"
                        role="radiogroup"
                        aria-label="Gender"
                      >
                        {["Male", "Female"].map((opt) => (
                          <button
                            key={opt}
                            type="button"
                            id={
                              opt === "Male" ? "gender_male" : "gender_female"
                            }
                            className={`sr-choice-chip${
                              state.gender === opt ? " is-active" : ""
                            }`}
                            onClick={() =>
                              handleGenderChange({ target: { value: opt } })
                            }
                            disabled={busy}
                          >
                            {opt}
                          </button>
                        ))}
                      </div>
                    </Field>
                  </div>
                </div>

                <div className="stur-basic__group stur-basic__group--demographics">
                  <div className="stur-basic__group-head">
                    <span className="stur-basic__group-title">Demographics</span>
                    <span className="stur-basic__group-line" aria-hidden />
                  </div>
                  <div className="stur-basic__grid stur-basic__grid--4">
                    <Field
                      label="Community"
                      htmlFor="community_sc"
                      required
                      className="usd-field--wide"
                    >
                      <div
                        className="sr-chip-row"
                        role="radiogroup"
                        aria-label="Community"
                      >
                        {COMMUNITY_OPTIONS.map((opt) => (
                          <button
                            key={opt}
                            type="button"
                            id={
                              opt === "SC"
                                ? "community_sc"
                                : `community_${opt.toLowerCase()}`
                            }
                            className={`sr-choice-chip${
                              state.community === opt ? " is-active" : ""
                            }`}
                            onClick={() =>
                              handleCommunityChange({
                                target: { value: opt },
                              })
                            }
                            disabled={busy}
                          >
                            {opt}
                          </button>
                        ))}
                        {state.community &&
                        !COMMUNITY_OPTIONS.includes(state.community) ? (
                          <button
                            type="button"
                            className="sr-choice-chip is-active"
                            disabled={busy}
                          >
                            {state.community}
                          </button>
                        ) : null}
                      </div>
                    </Field>
                    <Field label="Religion" htmlFor="RELIGION" optional>
                      <select
                        className="sr-input sr-select"
                        id="RELIGION"
                        value={state.RELIGION}
                        onChange={handleChange}
                        disabled={busy}
                      >
                        <option value="">Select</option>
                        {RELIGIONS.map((r) => (
                          <option key={r} value={r}>
                            {r}
                          </option>
                        ))}
                        {state.RELIGION &&
                        !RELIGIONS.includes(state.RELIGION) ? (
                          <option value={state.RELIGION}>
                            {state.RELIGION}
                          </option>
                        ) : null}
                      </select>
                    </Field>
                    <Field label="Caste" htmlFor="caste" optional>
                      <input
                        type="text"
                        className="sr-input"
                        id="caste"
                        value={state.caste}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field label="Nationality" htmlFor="nationality" optional>
                      <input
                        type="text"
                        className="sr-input"
                        id="nationality"
                        value={state.nationality}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                  </div>
                </div>

                <div className="stur-basic__group stur-basic__group--physical">
                  <div className="stur-basic__group-head">
                    <span className="stur-basic__group-title">
                      Physical &amp; other
                    </span>
                    <span className="stur-basic__group-line" aria-hidden />
                  </div>
                  <div className="stur-basic__grid stur-basic__grid--4">
                    <Field label="Blood Group" htmlFor="bloodgroup" optional>
                      <select
                        className="sr-input sr-select"
                        id="bloodgroup"
                        value={state.bloodgroup}
                        onChange={handleChange}
                        disabled={busy}
                      >
                        <option value="">Select</option>
                        {BLOOD_GROUPS.map((bg) => (
                          <option key={bg} value={bg}>
                            {bg}
                          </option>
                        ))}
                      </select>
                    </Field>
                    <Field
                      label="Mother Tongue"
                      htmlFor="mother_tongue"
                      optional
                    >
                      <select
                        className="sr-input sr-select"
                        id="mother_tongue"
                        value={state.mother_tongue}
                        onChange={handleChange}
                        disabled={busy}
                      >
                        <option value="">Select</option>
                        {MOTHER_TONGUE_OPTIONS.map((tongue) => (
                          <option key={tongue} value={tongue}>
                            {tongue}
                          </option>
                        ))}
                        {state.mother_tongue &&
                        !MOTHER_TONGUE_OPTIONS.includes(state.mother_tongue) ? (
                          <option value={state.mother_tongue}>
                            {state.mother_tongue}
                          </option>
                        ) : null}
                      </select>
                    </Field>
                    <Field label="Birth Place" htmlFor="birth_place" optional>
                      <input
                        type="text"
                        className="sr-input"
                        id="birth_place"
                        value={state.birth_place}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field label="Height (cm)" htmlFor="height" optional>
                      <input
                        type="text"
                        className="sr-input"
                        id="height"
                        value={state.height}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field label="Weight (kg)" htmlFor="weight" optional>
                      <input
                        type="text"
                        className="sr-input"
                        id="weight"
                        value={state.weight}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field
                      label="BPL Beneficiary"
                      htmlFor="bpl_beneficiary"
                      optional
                    >
                      <select
                        className="sr-input sr-select"
                        id="bpl_beneficiary"
                        value={state.bpl_beneficiary}
                        onChange={handleChange}
                        disabled={busy}
                      >
                        {YES_NO.map((v) => (
                          <option key={v} value={v}>
                            {v}
                          </option>
                        ))}
                      </select>
                    </Field>
                    <Field
                      label="Physical Disability"
                      htmlFor="physical_disability"
                      optional
                    >
                      <select
                        className="sr-input sr-select"
                        id="physical_disability"
                        value={state.physical_disability}
                        onChange={handleChange}
                        disabled={busy}
                      >
                        {YES_NO.map((v) => (
                          <option key={v} value={v}>
                            {v}
                          </option>
                        ))}
                      </select>
                    </Field>
                  </div>
                </div>

                <div className="stur-basic__group stur-basic__group--adm-ids">
                  <div className="stur-basic__group-head">
                    <span className="stur-basic__group-title">Locality</span>
                    <span className="stur-basic__group-line" aria-hidden />
                  </div>
                  <div className="stur-basic__grid stur-basic__grid--3">
                    <Field label="Village / Town" htmlFor="village_town">
                      <input
                        type="text"
                        className="sr-input"
                        id="village_town"
                        value={state.village_town}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field label="Post / Locality" htmlFor="post_locality">
                      <input
                        type="text"
                        className="sr-input"
                        id="post_locality"
                        value={state.post_locality}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field label="Police Station" htmlFor="police_station">
                      <input
                        type="text"
                        className="sr-input"
                        id="police_station"
                        value={state.police_station}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                  </div>
                </div>
              </div>
            </SectionCard>

            <SectionCard
              icon={FaMapMarkerAlt}
              step="04"
              title="Address"
              subtitle="Current and permanent residence"
            >
              <div className="stur-basic">
                <div className="stur-basic stur-address-panels">
                  <div className="stur-basic__group stur-basic__group--addr-current">
                    <div className="stur-basic__group-head">
                      <span className="stur-basic__group-title">Current</span>
                      <span className="stur-basic__group-line" aria-hidden />
                    </div>
                    <Field
                      label="Current Address"
                      htmlFor="current_address"
                      className="usd-field--wide"
                    >
                      <input
                        type="text"
                        className="sr-input"
                        id="current_address"
                        value={state.current_address}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                  </div>
                  <div className="stur-basic__group stur-basic__group--addr-permanent">
                    <div className="stur-basic__group-head">
                      <span className="stur-basic__group-title">Permanent</span>
                      <span className="stur-basic__group-line" aria-hidden />
                    </div>
                    <label className="stur-same-toggle">
                      <input
                        type="checkbox"
                        id="copyAddress"
                        onChange={handleCopyAddress}
                        disabled={busy}
                      />
                      <span>Same as current address</span>
                    </label>
                    <Field
                      label="Permanent Address"
                      htmlFor="permanent_address"
                      className="usd-field--wide"
                    >
                      <input
                        type="text"
                        className="sr-input"
                        id="permanent_address"
                        value={state.permanent_address}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                  </div>
                </div>
              </div>
            </SectionCard>

            <SectionCard
              icon={FaUserFriends}
              step="05"
              title="Family"
              subtitle="Father and mother details"
            >
              <div className="stur-basic">
                <div className="stur-basic__group stur-basic__group--family-father">
                  <div className="stur-basic__group-head">
                    <span className="stur-basic__group-title">Father</span>
                    <span className="stur-basic__group-line" aria-hidden />
                  </div>
                  <div className="stur-basic__grid stur-basic__grid--4">
                    <Field label="Father's Name" htmlFor="FatherName">
                      <input
                        type="text"
                        className="sr-input"
                        id="FatherName"
                        value={state.FatherName}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field
                      label="Father's Occupation"
                      htmlFor="fatherOccupation"
                    >
                      <input
                        type="text"
                        className="sr-input"
                        id="fatherOccupation"
                        value={state.fatherOccupation}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field
                      label="Father's Qualification"
                      htmlFor="father_qualification"
                      optional
                    >
                      <input
                        type="text"
                        className="sr-input"
                        id="father_qualification"
                        value={state.father_qualification}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field
                      label="Father's Aadhaar"
                      htmlFor="father_aadhar"
                      optional
                    >
                      <input
                        type="text"
                        className="sr-input"
                        id="father_aadhar"
                        value={state.father_aadhar}
                        onChange={handleChange}
                        maxLength={12}
                        inputMode="numeric"
                        disabled={busy}
                      />
                    </Field>
                  </div>
                </div>
                <div className="stur-basic__group stur-basic__group--family-mother">
                  <div className="stur-basic__group-head">
                    <span className="stur-basic__group-title">Mother</span>
                    <span className="stur-basic__group-line" aria-hidden />
                  </div>
                  <div className="stur-basic__grid stur-basic__grid--4">
                    <Field label="Mother's Name" htmlFor="motherName">
                      <input
                        type="text"
                        className="sr-input"
                        id="motherName"
                        value={state.motherName}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field
                      label="Mother's Occupation"
                      htmlFor="motherOccupation"
                    >
                      <input
                        type="text"
                        className="sr-input"
                        id="motherOccupation"
                        value={state.motherOccupation}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field
                      label="Mother's Qualification"
                      htmlFor="mother_qualification"
                      optional
                    >
                      <input
                        type="text"
                        className="sr-input"
                        id="mother_qualification"
                        value={state.mother_qualification}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field
                      label="Mother's Aadhaar"
                      htmlFor="mother_aadhar"
                      optional
                    >
                      <input
                        type="text"
                        className="sr-input"
                        id="mother_aadhar"
                        value={state.mother_aadhar}
                        onChange={handleChange}
                        maxLength={12}
                        inputMode="numeric"
                        disabled={busy}
                      />
                    </Field>
                  </div>
                </div>
              </div>
            </SectionCard>

            <SectionCard
              icon={FaUserPlus}
              step="06"
              title="Guardians"
              subtitle="On file (view only)"
            >
              {state.guardians?.length > 0 ? (
                <div className="stur-basic">
                  {state.guardians.map((g, index) => (
                    <div
                      key={g.gaurdian_id || index}
                      className={`stur-basic__group ${
                        index % 2 === 0
                          ? "stur-basic__group--contact-1"
                          : "stur-basic__group--contact-2"
                      }`}
                    >
                      <div className="stur-basic__group-head">
                        <span className="stur-basic__group-title">
                          Guardian {index + 1}
                        </span>
                        <span className="stur-basic__group-line" aria-hidden />
                      </div>
                      <div className="stur-basic__grid stur-basic__grid--4">
                        <Field label="Name">
                          <span className="sr-input usd-ro">
                            {fmt(g.gaurdian_name)}
                          </span>
                        </Field>
                        <Field label="Relation">
                          <span className="sr-input usd-ro">
                            {fmt(g.gaurdian_relation)}
                          </span>
                        </Field>
                        <Field label="Contact">
                          <span className="sr-input usd-ro">
                            {fmt(g.gaurdian_contact_no)}
                          </span>
                        </Field>
                        <Field label="Aadhaar">
                          <span className="sr-input usd-ro">
                            {fmt(g.gaurdian_aadhar)}
                          </span>
                        </Field>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="usd-empty-hint">No guardian details on file.</p>
              )}
            </SectionCard>

            <SectionCard
              icon={FaPhoneAlt}
              step="07"
              title="Contact Details"
              subtitle="Phone numbers and email"
            >
              <div className="stur-basic">
                <div className="stur-basic__group stur-basic__group--contact-1">
                  <div className="stur-basic__group-head">
                    <span className="stur-basic__group-title">Contact 1</span>
                    <span className="stur-basic__group-line" aria-hidden />
                  </div>
                  <div className="stur-basic__grid stur-basic__grid--3">
                    <Field label="Number" htmlFor="contact1">
                      <input
                        type="tel"
                        className="sr-input"
                        id="contact1"
                        value={state.contact1}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field label="Name" htmlFor="contactName_1">
                      <input
                        type="text"
                        className="sr-input"
                        id="contactName_1"
                        value={state.contactName_1}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field label="Relation" htmlFor="relation_1">
                      <select
                        className="sr-input sr-select"
                        id="relation_1"
                        value={state.relation_1}
                        onChange={handleChange}
                        disabled={busy}
                      >
                        {RELATION_OPTIONS.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                    </Field>
                  </div>
                </div>
                <div className="stur-basic__group stur-basic__group--contact-2">
                  <div className="stur-basic__group-head">
                    <span className="stur-basic__group-title">Contact 2</span>
                    <span className="stur-basic__group-line" aria-hidden />
                  </div>
                  <div className="stur-basic__grid stur-basic__grid--3">
                    <Field label="Number" htmlFor="contact2">
                      <input
                        type="tel"
                        className="sr-input"
                        id="contact2"
                        value={state.contact2}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field label="Name" htmlFor="contactName_2">
                      <input
                        type="text"
                        className="sr-input"
                        id="contactName_2"
                        value={state.contactName_2}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                    <Field label="Relation" htmlFor="relation_2">
                      <select
                        className="sr-input sr-select"
                        id="relation_2"
                        value={state.relation_2}
                        onChange={handleChange}
                        disabled={busy}
                      >
                        {RELATION_OPTIONS.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                    </Field>
                  </div>
                </div>
                <div className="stur-basic__group stur-basic__group--contact-email">
                  <div className="stur-basic__grid stur-basic__grid--email">
                    <Field label="Email Address" htmlFor="email" optional>
                      <input
                        type="email"
                        className="sr-input"
                        id="email"
                        value={state.email}
                        onChange={handleChange}
                        disabled={busy}
                      />
                    </Field>
                  </div>
                </div>
              </div>
            </SectionCard>

            <div className="sr-actions stur-actions usd-actions">
              <div className="stur-actions__btns">
                <button
                  type="button"
                  className="sr-btn sr-btn--ghost"
                  onClick={goToDetails}
                  disabled={busy}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="sr-btn sr-btn--primary"
                  disabled={busy}
                >
                  <FaSave aria-hidden />
                  {loading ? "Saving…" : "Update Student Details"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateStudentDetails;
